/* eslint-disable max-len */
import React from 'react';
import { Pane, Flex, Text, Toggle, Label, Dialogs } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import TwoFactorMethodsPane from "./TwoFactorMethodsPane.js";
import { getMethodsFor } from "./methods/Methods.js";
import Disable2FAMethodFlow from "./flows/Disable2FAMethodFlow.js";
import TwoStepModal from "./TwoStepModal.js";
import Enable2FAFlow from "./flows/Enable2FAFlow.js";
import Disable2FAFlow from "./flows/Disable2FAFlow.js";
import S from './TwoFactor.css';
import ViewCodesFlow from "./flows/ViewCodesFlow.js";
const {
  t
} = I18N.ns('login.twoFactor.TwoFactorPane');
export default class TwoFactorPane extends React.Component {
  constructor(props) {
    super(props);
    this.title = Config.get('SecurityScreen', 'twoFactorTitle', t('twoFactorTitle'));
    this.icon = Config.get('SecurityScreen', 'twoFactorIcon', t('twoFactorIcon', 'https://molten-ui-assets.storage.googleapis.com/security-title.png'));
  }
  onToggle2FA = evt => {
    const {
      value
    } = evt;
    const flow = value ? Enable2FAFlow : Disable2FAFlow;
    Dialogs.show({
      component: TwoStepModal,
      props: {
        ...this.props,
        title: this.title,
        icon: this.icon,
        flow
      }
    });
  };
  onToggle2FAMethod = ({
    value,
    data
  }) => {
    const {
      profile
    } = this.props;
    const {
      method
    } = data;
    const methodsEnabled = Object.keys(profile.twoFactor?.methods || {});
    let flow;
    if (value) {
      flow = Enable2FAFlow;
    } else if (methodsEnabled.length === 1) {
      flow = Disable2FAFlow;
    } else {
      flow = Disable2FAMethodFlow;
    }
    Dialogs.show({
      component: TwoStepModal,
      props: {
        ...this.props,
        title: this.title,
        icon: this.icon,
        method,
        flow
      }
    });
  };
  onViewCodes = () => {
    Dialogs.show({
      component: TwoStepModal,
      props: {
        ...this.props,
        title: this.title,
        icon: this.icon,
        flow: ViewCodesFlow
      }
    });
  };
  render() {
    const {
      project2FASettings,
      profile
    } = this.props;
    if (!project2FASettings?.enabled) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Pane, {
      layout: "flex:colL",
      variant: "contentSection",
      className: S.twoFactorPane
    }, /*#__PURE__*/React.createElement(Flex, {
      variant: "setting|colM"
    }, /*#__PURE__*/React.createElement(Text, {
      variant: "sectionTitle|title"
    }, this.title), /*#__PURE__*/React.createElement(Text, {
      variant: "sectionBody|subtitle"
    }, Config.get('SecurityScreen', 'twoFactorSubtitle', t('twoFactorSubtitle')))), !project2FASettings.required && /*#__PURE__*/React.createElement(Flex, {
      variant: "rowM",
      align: "center"
    }, /*#__PURE__*/React.createElement(Toggle, {
      id: "twoFactorActive",
      value: profile.twoFactor?.active,
      onChange: this.onToggle2FA
    }), /*#__PURE__*/React.createElement(Label, {
      htmlFor: "twoFactorActive"
    }, profile.twoFactor?.active ? t('on') : t('off'))), profile.twoFactor?.active && /*#__PURE__*/React.createElement(TwoFactorMethodsPane, {
      profile: profile,
      getMethodsFor: getMethodsFor,
      onToggleMethod: this.onToggle2FAMethod,
      onViewCodes: this.onViewCodes,
      project2FASettings: project2FASettings
    }));
  }
}